var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 8,
    fill: "#00A1FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4.235a.685.685 0 0 1 .299.067.726.726 0 0 1 .199.14l-.062-.056c.024.02.047.04.069.062l4.228 4.213a.706.706 0 0 1 .002.998l-.066.06a.706.706 0 0 1-.932-.058l-3.031-3.02v12.418c0 .362-.273.66-.624.701l-.082.005a.706.706 0 0 1-.706-.706V6.64l-3.031 3.02a.706.706 0 0 1-.932.057l-.067-.059a.706.706 0 0 1 .002-.998l4.229-4.213a.715.715 0 0 1 .4-.205.704.704 0 0 1 .105-.008l-.063.003a.713.713 0 0 1 .05-.003H12z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.d6d4677911fb26963b4756fff8477bc6.svg";
export { ForwardRef as ReactComponent };